import { ocapiClient } from '../../../api-clients/ocapi/client';
/**
 * Gets a Google Pay pass for a specified Journey.
 */
export const loadGooglePayPassForJourney = async (journeyId) => {
    return ocapiClient.instance.v1.journeys.thirdPartyPasses.getGooglePayPass(journeyId);
};
